import React, { useEffect } from "react";
import { useRouter } from "next/router";

import AuthorData from "../../../data/authors.json";
// import BlogData from "../../../data/tutorials.json";
import PageHead from "@/pages/Head";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import MobileMenu from "@/components/Header/MobileMenu";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import Cart from "@/components/Header/Offcanvas/Cart";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
import BlogDetails from "@/components/Blogs/BlogDetails";
import BlogListItems from "@/components/Blogs/Blog-Sections/BlogList-Items";
import Instagram from "@/components/Instagram/Instagram";
import BlogBreadCrumb from "@/components/Common/Blog-BreadCrumb";
// import { serialize } from 'next-mdx-remote/serialize'
// import { MDXRemote } from 'next-mdx-remote'
// import { readFile } from 'fs/promises'
// import rehypePrism from 'rehype-prism-plus';
// import rehypeCodeTitles from 'rehype-code-titles';
import CPStaticContent from '../../../models/CPStaticContent.js'

export default function SingleBlog( tutorial ) {
  const router = useRouter();
  const tutorialId = router.query.tutorialId;
  // const tutorialId = tutorial.id;
  // const tutorialInfo = tutorial.info;
  const mdxSource = tutorial.content
  const allTutorials = tutorial.list
  const tutorialInfo = tutorial.info
  //  allTutorials.find((item) => item.content_id === tutorialId);
  // console.log(tutorialId)

  const authors = JSON.parse(JSON.stringify(AuthorData.authorList));
  const Author = authors.find((author) => author.id === "akbar-hussain");
  tutorialInfo['position'] = "Tutorials"
  tutorialInfo['author'] = [Author]
  const matchedBlog = tutorialInfo
  // if (blogId <= 14) {

  // const tutorials = BlogData.tutorialList;
  // console.log(tutorials)
  // const blogPosts = tutorials;
  // const blogPosts = JSON.parse(JSON.stringify(tutorials));
  // const tutorials = JSON.parse(JSON.stringify(BlogData.blogGrid));

  // } else {
  //   blogPosts = JSON.parse(JSON.stringify(BlogData.blogGrid));
  // }

  // const matchedBlog = tutorials.find((blog) => blog.id === tutorialId);

  useEffect(() => {
    if (tutorialId && !matchedBlog) {
      router.push("/tutorials");
    }
  }, [matchedBlog, router]);

  // console.log(matchedBlog)

  return (
    <>
      <PageHead post={matchedBlog} category={"Tutorial"} />
      <Provider store={Store}>
        <Context>
          <MobileMenu />
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          <Cart />

          <div className="rbt-overlay-page-wrapper">
            <BlogBreadCrumb matchedBlog={matchedBlog} categoryName={"Tutorials"} categoryPath={"/tutorials"} />

            <div className="rbt-blog-details-area rbt-section-gapBottom breadcrumb-style-max-width">
              <div className="blog-content-wrapper rbt-article-content-wrapper">

                <BlogDetails
                  blogType={"terraform-module"}
                  matchedBlog={matchedBlog !== undefined ? matchedBlog : ""}
                  blogContent={mdxSource}
                  author={Author}
                />
                <div className="related-post pt--60">
                  <div className="section-title text-start mb--40">
                    <span className="subtitle bg-primary-opacity">
                      Continue Learning
                    </span>
                    <h4 className="title">Other Tutorials</h4>
                  </div>
                  <BlogListItems
                    blogType={"tutorial"}
                    selectedBlogs={tutorial.similar}
                    itemIdToAvoid={tutorialId}
                    start={0}
                    end={10}
                  />
                </div>
              </div>
            </div>

            <Instagram />
          </div>

          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export async function getStaticProps(context) {
  const stContent = new CPStaticContent("tutorials")
  await stContent.fetchContent()
  return await stContent.getItemProps(context.params.postId)
}

export async function getStaticPaths(context) {
  const stContent = new CPStaticContent("tutorials")
  await stContent.fetchContent()
  const paths = await stContent.getPaths()
  return { paths, fallback: false }
}